import { decodeBase64, encodeBase64 } from "./base64-utils";
import { ellipsifyHtml } from "./ellipsify-html";
import { ellipsifyText } from "./ellipsify-text";
import { generateId } from "./generate-id";
import { removeNotAlphanumericChars } from "./remove-not-alphanumeric-chars";
import { replaceInTemplate } from "./replace-in-template";

export const StringUtils = {
    generateId,
    replaceInTemplate,
    ellipsifyText,
    ellipsifyHtml,
    removeNotAlphanumericChars,
    encodeBase64,
    decodeBase64,
};
export { EllipsifyHtmlDirective } from "./ellipsify-html.directive";
export { EllipsifyHtmlPipe } from "./ellipsify-html.pipe";
export { EllipsifyTextPipe } from "./ellipsify-text.pipe";
export { LinkifyPipe } from "./linkify.pipe";
